

// import React from 'react';
// import { Menu } from '@headlessui/react';
// // import { ChevronDownIcon, UserCircleIcon } from '@heroicons/react/24/outline';

// export default function Navbar() {
//   return (
//     <div className="bg-gray-900 h-16 px-6 flex items-center border-b border-gray-700 justify-between w-full relative">
//       <div className="flex items-center gap-4 flex-1 justify-end">
//         <p className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-500 text-lg font-semibold">
//           Welcome to E-Payroll
//         </p>
        
//         <Menu as="div" className="relative">
//           <div>
//             <Menu.Button className="flex items-center gap-1 hover:bg-gray-800 rounded-full p-1 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-cyan-500">
//               <div
//                 className="h-10 w-10 rounded-full bg-cyan-500 border-2 border-cyan-300 bg-cover bg-no-repeat bg-center shadow-lg hover:scale-105 transition-transform"
//                 style={{ backgroundImage: 'url("https://i.pinimg.com/474x/67/c3/d6/67c3d63e215e034e01d45c8256d720d3.jpg")' }}
//               />
//               {/* <ChevronDownIcon className="h-4 w-4 text-cyan-300" /> */}
//             </Menu.Button>
//           </div>

//           {/* <Menu.Items className="absolute right-0 mt-2 w-48 origin-top-right rounded-lg bg-gray-800 shadow-xl focus:outline-none divide-y divide-gray-700">
//             <div className="p-1.5">
//               <Menu.Item>
//                 {({ active }) => (
//                   <button
//                     className={`${
//                       active ? 'bg-cyan-600 text-white' : 'text-cyan-100'
//                     } group flex w-full items-center rounded-md px-3 py-2.5 text-sm gap-2 transition-colors`}
//                   >
//                     <UserCircleIcon className="h-5 w-5" />
//                     Profile
//                   </button>
//                 )}
//               </Menu.Item>
//               <Menu.Item>
//                 {({ active }) => (
//                   <button
//                     className={`${
//                       active ? 'bg-cyan-600 text-white' : 'text-cyan-100'
//                     } group flex w-full items-center rounded-md px-3 py-2.5 text-sm gap-2 transition-colors`}
//                   >
//                     <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
//                       <path fillRule="evenodd" d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z" clipRule="evenodd" />
//                     </svg>
//                     Settings
//                   </button>
//                 )}
//               </Menu.Item>
//               <Menu.Item>
//                 {({ active }) => (
//                   <button
//                     className={`${
//                       active ? 'bg-rose-600 text-white' : 'text-rose-100'
//                     } group flex w-full items-center rounded-md px-3 py-2.5 text-sm gap-2 transition-colors`}
//                   >
//                     <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
//                       <path fillRule="evenodd" d="M3 3a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z" clipRule="evenodd" />
//                     </svg>
//                     Logout
//                   </button>
//                 )}
//               </Menu.Item>
//             </div>
//           </Menu.Items> */}
//         </Menu>
//       </div>
//     </div>
//   );
// }


import React, { useEffect, useState } from 'react';
import { Menu } from '@headlessui/react';

export default function Navbar() {
  const [role, setRole] = useState("");

  useEffect(() => {
    const storedRole = localStorage.getItem("role");
    if (storedRole) {
      setRole(storedRole);
    }
  }, []);

  return (
    <div className="bg-gray-900 h-16 px-6 flex items-center border-b border-gray-700 justify-between w-full relative">
      <div className="flex items-center gap-4 flex-1 justify-end">
        <p className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-500 text-lg font-semibold">
          Welcome to {role ? role : "E-Payroll"}
        </p>

        <Menu as="div" className="relative">
          <div>
            <Menu.Button className="flex items-center gap-1 hover:bg-gray-800 rounded-full p-1 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-cyan-500">
              <div
                className="h-10 w-10 rounded-full bg-cyan-500 border-2 border-cyan-300 bg-cover bg-no-repeat bg-center shadow-lg hover:scale-105 transition-transform"
                style={{ backgroundImage: 'url("https://i.pinimg.com/474x/67/c3/d6/67c3d63e215e034e01d45c8256d720d3.jpg")' }}
              />
            </Menu.Button>
          </div>
        </Menu>
      </div>
    </div>
  );
}
